// extracted by mini-css-extract-plugin
module.exports = {"root":"Images45_root__3oT2O","title":"Images45_title__QtZpO","images":"Images45_images__-5vvS"};